<template>
  <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
    <v-row dense class="pt-6">
      <v-col cols="12" sm="4" md="4" lg="2">
        <v-text-field class="search-field" v-model="search" prepend-icon="mdi-magnify" label="Search..." single-line
          solo hide-details />
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="2">
        <!-- Monthly Calendar -->
        <v-dialog v-if="commissionshistories?.profitShareTime === '30'" ref="dialog" v-model="modal"
          :return-value.sync="date" width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="date" prepend-icon="mdi-calendar" append-icon="mdi-chevron-down" readonly
              v-bind="attrs" v-on="on" solo class="custom-select"></v-text-field>
          </template>
          <v-date-picker v-model="date" type="month" class="custom-date-picker" scrollable>
            <v-spacer></v-spacer>
            <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="modal = false">
              Cancel
            </v-btn>
            <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="$refs.dialog.save(date)">
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>

        <!-- Daily Calendar -->
        <v-dialog v-if="commissionshistories?.profitShareTime === '1'" ref="dialog" v-model="modal"
          :return-value.sync="date" width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="date" prepend-icon="mdi-calendar" append-icon="mdi-chevron-down" readonly
              v-bind="attrs" v-on="on" solo class="custom-select"></v-text-field>
          </template>
          <v-date-picker v-model="date" class="custom-date-picker" scrollable>
            <v-spacer></v-spacer>
            <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="modal = false">
              Cancel
            </v-btn>
            <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="$refs.dialog.save(date)">
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>

        <!-- Weekly Calendar -->
        <v-dialog v-if="commissionshistories?.profitShareTime === '7'" ref="dialog" v-model="modal"
          :return-value.sync="date" width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field :value="weekDisplay" prepend-icon="mdi-calendar" append-icon="mdi-chevron-down" readonly
              v-bind="attrs" v-on="on" solo class="custom-select"></v-text-field>
          </template>
          <div class="custom-date-picker pa-4">
            <input type="week" :value="weekValue" @input="handleWeekChange" class="week-input"
              style="width: 100%; padding: 8px; margin-bottom: 16px; color: white;">
            <div class="d-flex justify-end">
              <v-btn :color="$vuetify.theme.dark ? '#ff567f' : '#ff567f'" text @click="modal = false" class="mr-2">
                Cancel
              </v-btn>
              <v-btn :color="$vuetify.theme.dark ? '#fff' : '#131c29'" text @click="$refs.dialog.save(date)">
                OK
              </v-btn>
            </div>
          </div>
        </v-dialog>
      </v-col>
      <v-col cols="12" sm="12" md="12" lg="8">
        <ul class="my-3 my-lg-0">
          <li v-for="(value, key) in commissionshistories?.summary" :key="key">
            <span>{{ key }}</span>
            <span>
              {{ formatSummaryValue(value) }} <strong>({{ formatSummaryTotal(value) }})</strong>
            </span>
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="12">
        <v-card class="pa-3 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
          <v-sheet class="transactionTable liveTradeTable depositTabTable pb-3"
            :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
            <v-data-table :search="search" :headers="dynamicHeaders" :items="formattedInvestorOrders"
              :items-per-page="6">
              <template v-slot:item.LoginView="{ item }">
                {{ item.investor_account }}
              </template>
              <template v-slot:item.TotalOrder="{ item }">
                {{ item.stats.orders.period }} ({{ item.stats.orders.total }})
              </template>
              <template v-slot:item.TotalLot="{ item }">
                {{ item.stats.lot.period }} ({{ item.stats.lot.total }})
              </template>
              <template v-slot:item.TotalProfit="{ item }">
                {{ formatProfit(item.stats.profit.period) }} ({{ formatProfit(item.stats.profit.total) }})
              </template>
              <template v-slot:item.ProfitShare="{ item }">
                {{ commissionshistories.profitSharePercentage }}%
              </template>
              <template v-slot:item.CommissionView="{ item }">
                {{ formatProfit(item.stats.commission.period) }} ({{ formatProfit(item.stats.commission.total) }})
              </template>
              <template v-slot:item.action="{ item }">
                <div v-if="!item?.isCommissionApproved">
                  <v-btn small tile elevation="0" :disabled="loading" :loading="loading" block class="ma-0 text-capitalize btn-account py-4" color="greenMain"
                    @click="handleApproveCommission(item)">
                    Approve
                  </v-btn>
                </div>
                <div v-else>
                  ...
                </div>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { MAM__ACTIONS } from "@/store/action-types";
import moment from 'moment';

export default {
  name: 'CommissionsHistory',

  data() {
    return {
      search: "",
      date: "",
      loading: false,
      modal: false,
      baseHeaders: [
        { text: "Login", value: "LoginView" },
        { text: "Order (Total)", value: "TotalOrder" },
        { text: "Lot (Total)", value: "TotalLot" },
        { text: "Profit (Total)", value: "TotalProfit" },
        { text: "Profit Share", value: "ProfitShare" },
        { text: "Commission", value: "CommissionView" },
      ],
    };
  },

  computed: {
    ...mapState("mam", ["commissionshistories"]),

    formattedInvestorOrders() {
      return this.commissionshistories?.investorOrders || [];
    },

    timePrefix() {
      if (!this.commissionshistories?.summary) return '';
      const firstKey = Object.keys(this.commissionshistories?.summary)[0];
      return firstKey.split(' ')[0] + ' ' + firstKey.split(' ')[1];
    },

    dynamicHeaders() {
      return this.baseHeaders.map(header => {
        if (['LoginView', 'ProfitShare'].includes(header.value)) {
          return header;
        }
        return {
          ...header,
          text: this.timePrefix ? `${this.timePrefix} ${header.text}` : header.text
        };
      });
    },

    weekValue() {
      if (!this.date) return '';
      const date = new Date(this.date);
      const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
      const weekNumber = Math.ceil(((date - firstDayOfYear) / 86400000 + firstDayOfYear.getDay() + 1) / 7);
      return `${date.getFullYear()}-W${weekNumber.toString().padStart(2, '0')}`;
    },

    weekDisplay() {
      if (!this.date) return '';
      const startDate = new Date(this.date);
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);
      return `${moment(startDate).format('MMM DD')} - ${moment(endDate).format('MMM DD, YYYY')}`;
    },
  },

  methods: {
    ...mapActions("mam", [
      MAM__ACTIONS.COMMISSIONSHISTORYTAB,
      MAM__ACTIONS.UPDATEINVESTORCOMMISSION,
    ]),

    initializeDate() {
      const today = new Date();

      switch (this.commissionshistories?.profitShareTime) {
        case '30': // Monthly
          this.date = moment(today).format('YYYY-MM');
          break;

        case '7': // Weekly
          const currentDay = today.getDay();
          const diff = currentDay === 0 ? -6 : 1 - currentDay; // Adjust to get Monday
          const monday = new Date(today);
          monday.setDate(today.getDate() + diff);
          this.date = monday.toISOString().split('T')[0];
          break;

        case '1': // Daily
          this.date = moment(today).format('YYYY-MM-DD');
          break;

        default:
          this.date = moment(today).format('YYYY-MM-DD');
      }
    },

    async loadCommissionData(params = {}) {
      const parameter = {
        account: this.$route.query.account,
        ...params
      };
      await this[MAM__ACTIONS.COMMISSIONSHISTORYTAB](parameter);
    },

    async handleDateSelection() {
      if (!this.date) return;

      let startTime, endTime;

      if (this.commissionshistories?.profitShareTime === '30') {
        const range = this.getMonthDateRange(this.date);
        startTime = range.start;
        endTime = range.end;
      } else if (this.commissionshistories?.profitShareTime === '7') {
        const range = this.getWeekDateRange(this.date);
        startTime = range.start;
        endTime = range.end;
      } else {
        startTime = moment(this.date).format('YYYY-MM-DD HH:mm:ss');
      }

      await this.loadCommissionData({ startTime, endTime });
    },

    getWeekDateRange(date) {
      const currentDate = new Date(date);
      // Adjust to Monday of the current week
      const day = currentDate.getDay() || 7;
      const diff = currentDate.getDate() - day + 1;

      const startDate = new Date(currentDate);
      startDate.setDate(diff);
      startDate.setHours(0, 0, 0, 0);

      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);
      endDate.setHours(23, 59, 59, 999);

      return {
        start: moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
        end: moment(endDate).format('YYYY-MM-DD HH:mm:ss')
      };
    },

    getMonthDateRange(date) {
      const currentDate = new Date(date);
      const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
      const endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(23, 59, 59, 999);

      return {
        start: moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
        end: moment(endDate).format('YYYY-MM-DD HH:mm:ss')
      };
    },

    formatProfit(value) {
      return value ? value.toFixed(2) : '0.00';
    },

    formatSummaryValue(value) {
      return value.split(' ')[0];
    },

    formatSummaryTotal(value) {
      const matches = value.match(/\(([^)]+)\)/);
      return matches ? matches[1] : '';
    },

    handleWeekChange(event) {
      const weekStr = event.target.value;
      if (!weekStr) return;

      const [year, week] = weekStr.split('-W').map(Number);

      // Get the first day of the year
      const firstDayOfYear = new Date(year, 0, 1);

      // Calculate the offset to the first day of the week (Monday)
      const dayOffset = firstDayOfYear.getDay();
      const offsetToMonday = dayOffset <= 1 ? 1 - dayOffset : 8 - dayOffset;

      // Calculate the start date of the selected week
      const weekStart = new Date(year, 0, 1 + offsetToMonday + (week - 1) * 7);

      // Set the date and trigger the selection handler
      this.date = weekStart.toISOString().split('T')[0];
      this.$nextTick(() => {
        this.handleDateSelection();
      });
    },

    async handleApproveCommission(item) {
      this.loading = true;
      try{
        await this[MAM__ACTIONS.UPDATEINVESTORCOMMISSION](item)
      }catch(error){
        console.error("Error approving commission:", error);
      }finally{
        this.loading = false;
      }
      
    },
  },

  watch: {
    'commissionshistories.profitShareTime': {
      immediate: true,
      handler(newVal) {
        if (newVal && !this.date) {
          this.initializeDate();
        }
      }
    },

    date: {
      handler(newVal) {
        if (newVal && this.$refs.dialog?.save) {
          this.handleDateSelection();
        }
      }
    }
  },

  async mounted() {
    await this.loadCommissionData();
    // Initialize date after data is loaded
    this.$nextTick(() => {
      if (this.commissionshistories?.profitShareTime) {
        this.initializeDate();
      }
    });
  },

  created() {
    if (this.$canRoute('manager') === 1) {
      this.headers.push({ text: "Action", value: "action" });
    }
  }
};
</script>
